import { render, staticRenderFns } from "./UserLogOut.vue?vue&type=template&id=050bd2d4&scoped=true&"
import script from "./UserLogOut.vue?vue&type=script&lang=js&"
export * from "./UserLogOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050bd2d4",
  null
  
)

export default component.exports